const toggleReadMores = document.querySelectorAll('.toggle-read-more');

function handleToggleClick(event) {
	event.preventDefault();
	const button = event.currentTarget;
	const parent = button.parentElement;
	const content = button.previousElementSibling;

	if (parent) {
		parent.classList.toggle('block-read-more--collapsed');
	}
	if (content) {
		if (null === content.offsetParent) {
			content.setAttribute('aria-hidden', 'true');
		} else {
			content.setAttribute('aria-hidden', 'false');
		}
	}
}

toggleReadMores.forEach((readMore) => {
	readMore.addEventListener('click', handleToggleClick);
});
